export const FIRST_NAME_INPUT_MAX_LEGTH = 16;
